"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalutationType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SalutationType_Factory = /** @class */ (function () {
    function SalutationType_Factory() {
    }
    SalutationType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            SalutationType1: model.SalutationType1,
            SalutationTypeCode: model.SalutationTypeCode,
        };
        return result;
    };
    SalutationType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            SalutationType1: model.SalutationType1,
            SalutationTypeCode: model.SalutationTypeCode,
        };
        return result;
    };
    return SalutationType_Factory;
}());
exports.SalutationType_Factory = SalutationType_Factory;
